import { c as _c } from "react/compiler-runtime";
import { HostingMapSkeleton } from "@/components/domain/hosting/hosting-map-skeleton";
import { KeyValueGrid } from "@/components/domain/key-value-grid";
import { KeyValueSkeleton } from "@/components/domain/key-value-skeleton";
import { ReportSection } from "@/components/domain/report-section";
import { sections } from "@/lib/constants/sections";
export function HostingSectionSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ReportSection isLoading={true} {...sections.hosting}><KeyValueGrid colsDesktop={3}><KeyValueSkeleton label="DNS" withLeading={true} widthClass="w-[100px]" /><KeyValueSkeleton label="Hosting" withLeading={true} widthClass="w-[100px]" /><KeyValueSkeleton label="Email" withLeading={true} widthClass="w-[100px]" /></KeyValueGrid><KeyValueSkeleton label="Location" withLeading={true} widthClass="w-[220px]" /><HostingMapSkeleton /></ReportSection>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}